import { render, staticRenderFns } from "./AddEmergencyLocationModal.vue?vue&type=template&id=70c1b75d&"
import script from "./AddEmergencyLocationModal.vue?vue&type=script&lang=js&"
export * from "./AddEmergencyLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports